import { ISendReportAction } from './sendReport.interface';

export enum SendReportTypes {
	SEND_REPORT = 'SEND_REPORT',
}

export type SendReportActions = ISendReportAction;
